const INPUT_STYLE = 'padding:8px 14px;border:2px solid #111;border-radius:0;font-size:13px;font-family:sans-serif;width:150px;outline:none;background:#fff;color:#111;letter-spacing:0.03em;';
const BTN_STYLE = 'padding:8px 16px;background:#cc0000;border:2px solid #cc0000;border-radius:0;cursor:pointer;font-size:12px;font-family:sans-serif;font-weight:700;letter-spacing:0.08em;color:#fff;white-space:nowrap;';
const AREA_BTN_STYLE = 'display:none;padding:8px 16px;background:#111;border:2px solid #111;border-radius:0;cursor:pointer;font-size:12px;font-family:sans-serif;font-weight:700;letter-spacing:0.08em;color:#fff;white-space:nowrap;';

export const crearInput = ({ onFocus, onBlur, onEnter, onInput }) => {
  const input = document.createElement('input');
  input.placeholder = 'Buscar lugares...';
  input.style.cssText = INPUT_STYLE;
  input.addEventListener('focus', () => { input.style.borderColor = '#cc0000'; onFocus?.(); });
  input.addEventListener('blur', () => { input.style.borderColor = '#111'; onBlur?.(); });
  input.addEventListener('keydown', e => { if (e.key === 'Enter') onEnter(); });
  input.addEventListener('input', e => onInput(e.target.value));
  return input;
};

export const crearBotonBuscar = (onClick) => {
  const btn = document.createElement('button');
  btn.textContent = 'BUSCAR';
  btn.style.cssText = BTN_STYLE;
  btn.addEventListener('mouseover', () => { btn.style.background = '#111'; btn.style.borderColor = '#111'; });
  btn.addEventListener('mouseout', () => { btn.style.background = '#cc0000'; btn.style.borderColor = '#cc0000'; });
  btn.addEventListener('click', onClick);
  return btn;
};

export const crearBotonBuscarArea = (onClick) => {
  const btn = document.createElement('button');
  btn.textContent = 'BUSCAR EN ESTA ÁREA';
  btn.style.cssText = AREA_BTN_STYLE;
  btn.addEventListener('mouseover', () => { btn.style.background = '#cc0000'; btn.style.borderColor = '#cc0000'; });
  btn.addEventListener('mouseout', () => { btn.style.background = '#111'; btn.style.borderColor = '#111'; });
  btn.addEventListener('click', onClick);
  return btn;
};

export const crearControlDiv = () => {
  const div = document.createElement('div');
  div.style.cssText = 'display:flex;align-items:center;gap:8px;margin:10px 10px 10px 140px;';
  return div;
};

export const limpiarMarcadores = (markersRef) => {
  markersRef.current.forEach(m => m.setMap(null));
  markersRef.current = [];
};

export const buscarPlaces = ({ map, query, usarBounds, markersRef, infoWindowRef, buscarAreaBtnRef, setLatLng }) => {
  if (!map || !query.trim()) return;

  if (buscarAreaBtnRef.current) buscarAreaBtnRef.current.style.display = 'none';

  limpiarMarcadores(markersRef);
  if (infoWindowRef.current) infoWindowRef.current.close();
  infoWindowRef.current = new window.google.maps.InfoWindow();

  const service = new window.google.maps.places.PlacesService(map);
  const request = { query };
  if (usarBounds) {
    request.bounds = map.getBounds();
  } else {
    request.location = map.getCenter();
    request.radius = 5000;
  }

  service.textSearch(request, (results, status) => {
    if (status !== window.google.maps.places.PlacesServiceStatus.OK || !results) return;

    results.forEach((place) => {
      if (!place.geometry?.location) return;

      const marker = new window.google.maps.Marker({
        map,
        position: place.geometry.location,
        title: place.name,
        icon: { url: 'https://maps.google.com/mapfiles/ms/icons/pink-dot.png' },
      });

      marker.addListener('click', () => {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();
        const fnKey = `__mandarPin_${lat}_${lng}`.replace(/\./g, '_');

        window[fnKey] = () => {
          setLatLng({ lat: lat + 0.0001, lng: lng + 0.0001 });
          infoWindowRef.current.close();
        };

        infoWindowRef.current.setHeaderContent(place.name);
        infoWindowRef.current.setContent(
          `<div style="font-family:sans-serif;font-size:12px;min-width:190px;color:#111;">
            <div style="color:#555;margin-bottom:10px;line-height:1.5;">${place.formatted_address || ''}</div>
            <button onclick="window['${fnKey}']()" style="width:100%;padding:7px 0;cursor:pointer;border:2px solid #cc0000;border-radius:0;background:#cc0000;color:#fff;font-size:11px;font-weight:700;letter-spacing:0.08em;">
              TRAER MARCADOR
            </button>
          </div>`
        );

        window.google.maps.event.clearListeners(infoWindowRef.current, 'closeclick');
        infoWindowRef.current.open(map, marker);
      });

      markersRef.current.push(marker);
    });
  });
};